<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ack">
<h1 class="chapter">ACKNOWLEDGMENTS</h1>
<p class="nonindent">Many individuals besides the authors contribute to the making of any book, and we are grateful to all who helped us. We especially thank our friends, Robert W. Parker, Racheal Ogan, Sharon Brown, Jackie Atchison, and Thomas Freese, who are always ready to help us search for tales to tell. We thank the storytellers who have died but live on in the stories they shared with us. We appreciate the support we have received from the University Press of Kentucky, especially Laura Sutton, who was there helping us every step of the way, and Donna Bouvier, who did an outstanding job editing this book.</p>
<p class="indent">Many others helped us with kindness, inspiration, and support while we were in the process of creating this book. Our thanks to both friends (especially Jerry Anderson, Mary Ann Ballard, Cathy Bohler, Marian Call, Grover and Linda Gaddie, Lori Graham of Alley Cat Café and Catering, Deanna Hansen, Anne Howard, Donna Ising, Denise Kirzinger, Norma Lewis, Shirley Meece, Robin Miller, Lynwood Montell, Lee and Joy Pennington, Joan Todd, and Candy and Dennis Wilson) and family (especially Charlie and Vicki Brown, Lewis Brown, El Wanda and Eddie Horsley, Dee and Billy Hurt, and Charles and Neline Kerr).</p>
<p class="indent">Thanks most of all to you, our readers, who we hope will enjoy our stories and pass them on in true Kentucky storytelling tradition.</p>
<p class="extract">We were not collectors when we first heard many of these stories, so we did not record the storyteller’s name or the time and place of the stories. Some of these stories are based on our own experiences, but many were told to us by more than one person over the years. The tellers included family, neighbors, friends, teachers, and students. In the tradition of storytelling, many of these tales were passed on from generation to generation, with the details often changing slightly with the telling.</p>
<p class="indent">We gratefully acknowledge below the individuals who have enriched our lives with the stories they shared, and whose stories we share with you in this book.</p>
<p class="center1">John Ackman</p>
<p class="center1">Polly Ackman</p>
<p class="center1">Edgar Anderson</p>
<p class="center1">Iona Anderson</p>
<p class="center1">Jerry Anderson</p>
<p class="center1">Ervin Atchley</p>
<p class="center1">Fatima Atchley</p>
<p class="center1">Katie Atchley</p>
<p class="center1">Cassie Brown</p>
<p class="center1">Conda Brown</p>
<p class="center1">Lena Brown</p>
<p class="center1">Lucian Brown</p>
<p class="center1">Sarah Brown</p>
<p class="center1">Anna Cravens</p>
<p class="center1">Jim Cravens</p>
<p class="center1">Mike Dean</p>
<p class="center1">Alice Gentry</p>
<p class="center1">Charlie Gentry</p>
<p class="center1">Hollis Gentry</p>
<p class="center1">Geraldine Brown Glascoe</p>
<p class="center1">Bob Gutman</p>
<p class="center1">Willie Harmon</p>
<p class="center1">Zola Harmon</p>
<p class="center1">Eva Hughes</p>
<p class="center1">Huley Hughes</p>
<p class="center1">Ola May (Foley) Martin</p>
<p class="center1">Amy Miller</p>
<p class="center1">James Milton “Buck” Rooks</p>
<p class="center1">George Simpson</p>
<p class="center1">Josh Simpson</p>
<p class="center1">Lawrence Simpson</p>
<p class="center1">Lillian Simpson</p>
<p class="center1">Lou Ann (Alley) Simpson</p>
<p class="center1">Louis Franklin Simpson</p>
<p class="center1">Milt Tom Simpson</p>
<p class="center1">Sam Simpson</p>
<p class="center1">Myrtie Gaskin Sullivan</p>
<p class="center1">Leland Voils</p>
<p class="center1">Martin Luther Wilson</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813173894_epub_ack_r1.vue?78cce114